//import VerticalStackedBarsChart from './verticalStackedBarsChart/VerticalStackedBarsChart'
import { useEffect } from 'react'
import { DashboardCard, SectionTitle } from '../../../../../ui'
//import MirrorTable from '../../../../../table/MirrorTable'
import TableTop5 from '../../../../../table/TableTop5'
//import { BarFilterHistoricalSearch } from '../../../../../ui/BarFilterHistoricalSearch'

import MirrorChart from '../../../../../charts/MirrorChart'
import { useBusinessInsightContext } from '../../../BusinessInsights/VisionDelNegocio/VisionContext/businessInsightContext'
import ChartPie from '../../../BusinessInsights/VisionDelNegocio/CharComponent/ChartPine'
import { Box } from '@mui/material'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'
import Lottie from 'lottie-react'
import PlanRestrictedButton from '../../../../../ui/PlanRestrictedButton'

const IngresosInsights = ({ summaryData, stateIngresoEgreso }) => {
  const { data: { topClients, topProviders, realVsBudget } } = useBusinessInsightContext()

  useEffect(() => {
    console.log('Top 5 clientes:', topClients)
    console.log('Top 5 proveedores:', topProviders)
  }, [topClients, topProviders])

  return (
    <div>
      {/*<div className='relative'>
          <BarFilterHistoricalSearch
            position='top'
            short
            currentOptionKey={period}
            onSelectOptionKey={setPeriod}
          />
        </div>*/}

      <div className='my-6 grid grid-cols-1 gap-2 pb-1 xl:grid-cols-2 xl:auto-rows-fr xl:items-stretch'>
        {/*<VerticalStackedBarsChart data={allData?.historicalVsCurrent} period={period} />*/}
        <PlanRestrictedButton
          dashboardType='basic'
          message='La concentración de gastos'
          className='w-full h-full'
        >
          <DashboardCard className='flex h-full flex-col text-center'>
            <SectionTitle className='mb-4 text-center'>Concentración de gastos</SectionTitle>
              {stateIngresoEgreso ? (
                <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                  <Lottie
                    animationData={LoaderMain}
                    loop
                    autoplay
                    style={{ width: 100, height: 100 }}
                  />
                </Box>
              ) : (
                <div className='flex-1 w-full flex items-center justify-center'>
                  <ChartPie summaryData={summaryData} />
                </div>
              )}
          </DashboardCard>
        </PlanRestrictedButton>
        <PlanRestrictedButton
          dashboardType='full'
          message='Real vs Presupuesto'
          className='w-full h-full'
        >
          <MirrorChart chartData={realVsBudget} />
        </PlanRestrictedButton>
      </div>
      <div className='my-6 grid grid-cols-1 gap-6 xl:grid-cols-2 xl:gap-2 xl:auto-rows-fr xl:items-stretch'>
        <PlanRestrictedButton
          dashboardType='full'
          message='Top 5 clientes'
          className='w-full h-full'
        >
          <TableTop5
            data={topClients}
            title='Top 5 clientes'
            header1='Cliente'
            header2='Total ventas'
          />
        </PlanRestrictedButton>
        <PlanRestrictedButton
          dashboardType='full'
          message='Top 5 proveedores'
          className='w-full h-full'
        >
          <TableTop5
            data={topProviders}
            title='Top 5 proveedores'
            header1='Proveedor'
            header2='Total compras'
          />
        </PlanRestrictedButton>
        {/*<MirrorTable
          totalPorCobrarPagar={allData?.totalPorCobrar}
          totalCobradasPagadas={allData?.totalCobradas}
          topData={allData?.porCobrar}
          bottomData={allData?.cobradas}
          title1='Por cobrar'
          title2='Cobradas'
        />*/}
      </div>
    </div>
  )
}

export default IngresosInsights
